import React from 'react';
import { Phone, Mail, MapPin, Clock, Send, User, MessageSquare, MessageCircle, Building } from 'lucide-react';

const Contact = () => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission here
    alert('Thank you for your message. We will get back to you soon!');
  };

  return (
    <div className="min-h-screen bg-gray-50 pt-32">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-blue-600 to-emerald-600 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Contact Ismail Property Advisor</h1>
            <p className="text-xl md:text-2xl text-blue-100 max-w-3xl mx-auto">
              Get in touch with our expert team at Faisal Hills. We're here to help you find your perfect property.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Info Cards */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center p-6">
              <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <Phone className="h-8 w-8 text-blue-600" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Mobile Numbers</h3>
              <div className="space-y-2">
                <div className="flex items-center justify-center space-x-2">
                  <a href="tel:+923335997663" className="text-gray-600 hover:text-blue-600 transition-colors">
                    +92-333-5997663
                  </a>
                  <a href="https://wa.me/923335997663" target="_blank" rel="noopener noreferrer" className="text-green-500 hover:text-green-600">
                    <MessageCircle className="h-4 w-4" />
                  </a>
                </div>
                <p className="text-sm text-gray-500">Ali Raza Shah (Main Contact)</p>
                <div className="flex items-center justify-center space-x-2">
                  <a href="tel:+923328563429" className="text-gray-600 hover:text-blue-600 transition-colors">
                    +92-332-8563429
                  </a>
                  <a href="https://wa.me/923328563429" target="_blank" rel="noopener noreferrer" className="text-green-500 hover:text-green-600">
                    <MessageCircle className="h-4 w-4" />
                  </a>
                </div>
                <p className="text-sm text-gray-500">Ali Murtaza</p>
                <div className="flex items-center justify-center space-x-2">
                  <a href="tel:+923344933389" className="text-gray-600 hover:text-blue-600 transition-colors">
                    +92-334-4933389
                  </a>
                  <a href="https://wa.me/923344933389" target="_blank" rel="noopener noreferrer" className="text-green-500 hover:text-green-600">
                    <MessageCircle className="h-4 w-4" />
                  </a>
                </div>
                <p className="text-sm text-gray-500">M Ismail</p>
              </div>
              <div className="mt-3 pt-3 border-t border-gray-200">
                <div className="flex items-center justify-center">
                  <Phone className="h-4 w-4 text-gray-400 mr-1" />
                  <a href="tel:0514500376" className="text-gray-600 hover:text-blue-600 transition-colors">
                    051-4500376
                  </a>
                </div>
                <p className="text-sm text-gray-500">Telephone</p>
              </div>
            </div>
            <div className="text-center p-6">
              <div className="bg-emerald-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <Mail className="h-8 w-8 text-emerald-600" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Email</h3>
              <a href="mailto:ismailproperty736@gmail.com" className="text-gray-600 hover:text-emerald-600 transition-colors">
                ismailproperty736@gmail.com
              </a>
              <p className="text-sm text-gray-500 mt-2">We respond within 24 hours</p>
            </div>
            <div className="text-center p-6">
              <div className="bg-purple-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <MapPin className="h-8 w-8 text-purple-600" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Office Location</h3>
              <p className="text-gray-600 mb-2">SUFFA FRIENDS</p>
              <p className="text-gray-600 mb-2">Office No. 42, Ittehad Business Centre</p>
              <p className="text-gray-600 mb-2">A-Block, Faisal Hills</p>
              <p className="text-sm text-gray-500">Near Taxila, Islamabad</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form & Map */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Contact Form */}
            <div className="bg-white rounded-lg shadow-lg p-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">Send us a Message</h2>
              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      <User className="inline h-4 w-4 mr-1" />
                      First Name
                    </label>
                    <input
                      type="text"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                      placeholder="John"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Last Name
                    </label>
                    <input
                      type="text"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                      placeholder="Doe"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    <Mail className="inline h-4 w-4 mr-1" />
                    Email Address
                  </label>
                  <input
                    type="email"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                    placeholder="john.doe@example.com"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    <Phone className="inline h-4 w-4 mr-1" />
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                    placeholder="+1 (555) 123-4567"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Subject
                  </label>
                  <select className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent">
                    <option>Property Inquiry</option>
                    <option>Schedule Viewing</option>
                    <option>Property Valuation</option>
                    <option>General Question</option>
                    <option>Partnership Opportunity</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    <MessageSquare className="inline h-4 w-4 mr-1" />
                    Message
                  </label>
                  <textarea
                    required
                    rows={5}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                    placeholder="Tell us about your property needs..."
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="w-full bg-primary-600 text-white py-3 rounded-lg hover:bg-primary-700 transition-colors font-medium inline-flex items-center justify-center"
                >
                  <Send className="h-5 w-5 mr-2" />
                  Send Message
                </button>
              </form>
            </div>

            {/* Map & Office Info */}
            <div className="space-y-8">
              {/* Map */}
              <div className="bg-white rounded-lg shadow-lg overflow-hidden h-96">
                <iframe
                  title="Office Location Map"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3024.2219901290355!2d-74.00369368400567!3d40.71312937933039!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25a316bb8b6b5%3A0x4b4b5b5b5b5b5b5b!2s123%20Business%20Ave%2C%20New%20York%2C%20NY%2010001!5e0!3m2!1sen!2sus!4v1234567890"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  className="w-full h-full"
                ></iframe>
              </div>

              {/* Office Hours */}
              <div className="bg-white rounded-lg shadow-lg p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-4">Office Hours</h3>
                <div className="space-y-3">
                  <div className="flex justify-between items-center">
                    <span className="text-gray-600">Monday - Sunday</span>
                    <span className="font-medium text-green-600">24/7 Available</span>
                  </div>
                </div>
                <div className="mt-6 p-4 bg-green-50 rounded-lg">
                  <div className="flex items-center">
                    <Clock className="h-5 w-5 text-green-600 mr-2" />
                    <p className="text-sm text-green-800">
                      We're available round the clock to assist you with your property needs. Call or WhatsApp us anytime!
                    </p>
                  </div>
                </div>
              </div>

              {/* Quick Contact */}
              <div className="bg-gradient-to-r from-blue-600 to-emerald-600 text-white rounded-lg shadow-lg p-6">
                <h3 className="text-xl font-semibold mb-4">Need Immediate Assistance?</h3>
                <p className="text-blue-100 mb-4">
                  For urgent property inquiries or to schedule an immediate viewing, contact Ali Raza Shah directly.
                </p>
                <div className="space-y-3">
                  <a
                    href="tel:+923335997663"
                    className="inline-flex items-center bg-white text-blue-600 px-6 py-3 rounded-lg hover:bg-blue-50 transition-colors font-medium w-full justify-center"
                  >
                    <Phone className="h-5 w-5 mr-2" />
                    Call Ali Raza Shah: +92-333-5997663
                  </a>
                  <a
                    href="https://wa.me/923335997663"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center bg-green-500 text-white px-6 py-3 rounded-lg hover:bg-green-600 transition-colors font-medium w-full justify-center"
                  >
                    <MessageCircle className="h-5 w-5 mr-2" />
                    WhatsApp Ali Raza Shah
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Frequently Asked Questions</h2>
            <p className="text-lg text-gray-600">Quick answers to common questions</p>
          </div>
          <div className="space-y-6">
            <div className="bg-gray-50 rounded-lg p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                How long does it typically take to sell a property?
              </h3>
              <p className="text-gray-600">
                On average, properties sell within 30-60 days in the current market. However, this can vary 
                based on location, price, and market conditions.
              </p>
            </div>
            <div className="bg-gray-50 rounded-lg p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                What services do you offer for first-time home buyers?
              </h3>
              <p className="text-gray-600">
                We provide comprehensive support including market analysis, property search, negotiation 
                assistance, and guidance through the entire buying process.
              </p>
            </div>
            <div className="bg-gray-50 rounded-lg p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Do you charge for property valuations?
              </h3>
              <p className="text-gray-600">
                Initial consultations and basic property valuations are complimentary. Detailed 
                appraisal services may have associated fees.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
